<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded width="100%" max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-container fluid class="d-flex justify-space-between pa-0">
          <h5 class="text-h5 font-weight-bold text-left">
            Nuevo Cliente&nbsp;<v-icon>mdi-account</v-icon>
          </h5>
          <v-btn
            color="accent"
            type="submit"
            form="client-form"
            :disabled="!valid"
          >
            <v-icon>mdi-content-save</v-icon>&nbsp;Guardar
          </v-btn>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-form
          id="client-form"
          ref="form"
          v-model="valid"
          @submit.prevent="add()"
        >
          <v-card outlined>
            <v-card-title class="font-weight-light"
              >Datos del cliente</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="userInfo.nombre"
                    hint="Nombre completo"
                    :rules="[validations.required]"
                    dense
                  >
                    <template #label>
                      <span>
                        Nombre del cliente
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="userInfo.rfc" label="RFC" dense>
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="userInfo.clave" label="Clave (ID SAP)" dense>
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="userInfo.correo"
                    type="email"
                    :rules="[validations.required, validations.email]"
                    dense
                  >
                    <template #label>
                      <span>
                        Email
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="userInfo.telefono"
                    :rules="[validations.required]"
                    dense
                  >
                    <template #label>
                      <span>
                        Teléfono
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "../components/PlatformLayout.vue";
import { required, email } from "@/helpers/formHelpers";
import { httpPost } from "@/services/apiService";

export default {
  name: "Cliente",
  components: {
    PlatformLayout,
  },
  data() {
    return {
      valid: false,
      overlay: false,
      userInfo: {
        nombre: null,
        correo: null,
        telefono: null,
        rfc: null,
        clave: null
      },
      validations: {
        required,
        email,
      },
    };
  },
  methods: {
    async add() {
      await httpPost("/clientes", { data: this.userInfo });
      this.$toasted.show("Cliente agregado", { type: "success" });
      this.$router.push("/platform/clientes");
    },
  },
};
</script>
